import React from "react";

export default function CenterManagerLearnerTable({
  learners,
  batches,
  onEdit,
  onRemoveBatch,
  onDeactivate,
  onReactivate,
}) {
  return (
    <section className="data-table-wrap" data-testid="center-manager-learners-table">
      <table>
        <thead>
          <tr>
            <th>Learner</th>
            <th>Email</th>
            <th>Batch</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {learners.map((learner) => (
            <tr key={learner.id} data-testid={`center-manager-learner-row-${learner.id}`}>
              <td>{learner.name}</td>
              <td>{learner.email}</td>
              <td>{batches.find((batch) => batch.id === learner.batch_id)?.name || "Unassigned"}</td>
              <td>{learner.active === false ? "Deactivated" : "Active"}</td>
              <td>
                <button
                  className="table-action"
                  onClick={() => onEdit(learner)}
                  data-testid={`center-manager-edit-learner-${learner.id}-button`}
                >
                  Edit
                </button>
                <button
                  className="table-action"
                  onClick={() => onRemoveBatch(learner.id)}
                  data-testid={`center-manager-remove-learner-batch-${learner.id}-button`}
                >
                  Remove batch
                </button>
                {learner.active === false ? (
                  <button
                    className="table-action"
                    onClick={() => onReactivate(learner.id)}
                    data-testid={`center-manager-reactivate-learner-${learner.id}-button`}
                  >
                    Reactivate
                  </button>
                ) : (
                  <button
                    className="table-action"
                    onClick={() => onDeactivate(learner.id)}
                    data-testid={`center-manager-deactivate-learner-${learner.id}-button`}
                  >
                    Deactivate
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}